import React from "react";
import { Box, Typography, Chip } from "@mui/material";

const statusColors = {
    connected: "success",
    connecting: "warning",
    disconnected: "error",
};

export function WebSocketStatus({ status }) {
    return (
        <Box display="flex" alignItems="center" gap={1}>
            <Typography variant="body2">Status:</Typography>
            <Chip
                label={status}
                color={statusColors[status] || "default"}
                size="small"
                variant="outlined"
            />
        </Box>
    );
}
